/*
1. no_cert -> go to upload certificate page
2. under_review, audit_on_hold, cert_expired -> go to tutor profile page
3. approved -> QA page
4. rejected -> go to tutor profile page, and explain his application is rejected.
 */
export const APPROVED = 'Approved';
export const NO_CERT = 'No_cert';
export const UNDER_REVIEW = 'Under_review';
export const REJECTED = 'Rejected';
export const AUDIT_ON_HOLD = 'Audit_on_hold';
export const CERT_EXPIRED = 'Cert_expired';
export const NEED_BANK_INFO = 'Need_bank_info';



// WEBPACK FOOTER //
// ./app/constants/tutorStatus.js